import React, { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { listSnapshots, markAsReference } from "../api"

const SamplesPanel = ({ checkId }) => {
  const [snapshots, setSnapshots] = useState([])
  const [loading, setLoading] = useState(false)

  const refresh = async () => {
    setLoading(true)
    const r = await listSnapshots(checkId)
    setSnapshots(r?.snapshots || [])
    setLoading(false)
  }

  useEffect(() => { refresh() }, [checkId])

  const onMarkRef = async (snapshotId) => {
    if (!confirm("Set this snapshot as reference?")) return
    const r = await markAsReference(checkId, snapshotId)
    if (r?.error) return alert("Error: " + r.error)
    refresh()
  }

  if (loading) return <div className="text-text_secondary text-sm">Loading samples...</div>
  if (snapshots.length === 0) return <div className="text-text_secondary text-sm">No samples yet.</div>

  return (
    <div className="space-y-2">
      <Typography variant="admin_h4">Sample snapshots ({snapshots.length})</Typography>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
        {snapshots.map((s) => (
          <div key={s._id} className="p-2 rounded border border-bordered bg-paper">
            <img
              src={`/v1/status/snapshot/${s._id}`}
              alt="snapshot"
              className="w-full h-24 object-cover rounded mb-1"
              loading="lazy"
            />
            <div className="text-xs text-text_secondary">
              {new Date(s.ts).toLocaleTimeString()}
              {s.diffPct != null && <span className="ml-1">{s.diffPct.toFixed(1)}% diff</span>}
            </div>
            <div className="flex gap-1 mt-1">
              {s.type !== "reference" && (
                <Button size="sm" variant="secondary" onClick={() => onMarkRef(s._id)}>
                  Mark as ref
                </Button>
              )}
              {s.type === "reference" && (
                <span className="text-xs text-success font-medium">Reference</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SamplesPanel
